var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventoryInIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1.33337 8.00065C1.33337 4.85795 1.33337 3.2866 2.30969 2.3103C3.28599 1.33398 4.85734 1.33398 8.00004 1.33398C11.1427 1.33398 12.7141 1.33398 13.6904 2.3103C14.6667 3.2866 14.6667 4.85795 14.6667 8.00065C14.6667 11.1433 14.6667 12.7147 13.6904 13.691C12.7141 14.6673 11.1427 14.6673 8.00004 14.6673C4.85734 14.6673 3.28599 14.6673 2.30969 13.691C1.33337 12.7147 1.33337 11.1433 1.33337 8.00065Z",
    fill: "#6F6F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35371 7.55405C8.25997 7.64785 8.13277 7.70052 8.00017 7.70052C7.86757 7.70052 7.74037 7.64785 7.64664 7.55405L5.44662 5.35408C5.25135 5.15881 5.25135 4.84223 5.44662 4.64697C5.64188 4.4517 5.95846 4.4517 6.15373 4.64696L7.50017 5.99341V1.33414C7.66224 1.33398 7.82877 1.33398 8.00004 1.33398C8.17137 1.33398 8.33804 1.33398 8.50017 1.33414V5.99341L9.84664 4.64696C10.0419 4.4517 10.3584 4.4517 10.5537 4.64696C10.749 4.84223 10.749 5.15881 10.5537 5.35407L8.35371 7.55405Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryInIcon);
export default __webpack_public_path__ + "static/media/inventory-in-icon.c618846136ad259f99a2ae2e4f7f695e.svg";
export { ForwardRef as ReactComponent };